module.exports = new __parcel__URL__("arrow.6dfe1608.svg").toString();